import { Component, Input, OnInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { stringify } from "querystring";
import { UserService } from "../../../../shared";
import { DataService_NotifyRegBatch } from "../shared/data.service";
import { GuardianImportPreviewRequest } from "../shared/GuardianImportPreviewRequest";
import { ImportPreviewRequest } from "../shared/ImportPreviewRequest";

@Component({
	selector: "caass-guardian-notify-import-preview",
	templateUrl: "./guardian-notify-import-preview.component.html",
	styleUrls: ["./guardian-notify-import-preview.component.css"],
})
export class GuardianNotifyImportPreviewComponent implements OnInit {
	constructor(private userService: UserService, private notifyService: DataService_NotifyRegBatch, private dialogService: DialogService) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		// this.user = this.userService.getCurrentUser();
		this.loadNotifyLanguages();

		this.loadPerson();
	}

	ngOnChanges() {
		this.loadPerson();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	lstNotifyLanguages: any = [];

	@Input() FormatOption: any;
	@Input() ImportFileData: any;

	AnyLoading: any = false;

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedPerson: any;
	lstPerson: any = [];

	//Filter lists
	lstSchoolName: any = [];
	lstStudentActiveDesc: any = [];
	lstParentActiveDesc: any = [];
	lstValidEntryDesc: any = [];
	lstProgressDesc: any = [];

	//Cols
	// cols1: any = [
	//   //INSERT CUSTOM COLUMNS HERE
	//   // { field: 'StudentID', header: 'Student ID' },
	//   // { field: 'StudentName', header: 'Name' },
	//   // { field: 'SchoolName', header: 'School' }
	//   // { field: 'StudentActiveDesc', header: 'Active' },
	// ]

	// cols2: any = [
	//   // { field: 'ParentName', header: 'Parent' },
	//   // { field: 'ParentEmail', header: 'Parent Email' },
	//   // { field: 'ParentActiveDesc', header: 'Active' },
	//   // { field: 'ValidEntryDesc', header: 'Valid Entry' },
	//   // { field: 'ProgressDesc', header: 'Progress' }

	// ];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadPerson() {
		if (this.FormatOption == undefined || this.ImportFileData == undefined) {
			return;
		}

		this.loading = true;

		let parms: ImportPreviewRequest = {
			FormatOption: this.FormatOption.ID,
			Base64File: this.ImportFileData,
		};

		var result = this.notifyService.LoadImportPreviewData(parms);
		result.subscribe(
			(response) => {
				this.lstPerson = response;

				for (var z = 0; z < this.lstPerson.length; z++) {
					var next = this.lstPerson[z];

					next.UID = Number(z + 1);
				}

				//Load Data Filter Lists
				this.lstSchoolName = Array.from(new Set(this.lstPerson.map((item: any) => item.SchoolName))).sort();
				this.lstStudentActiveDesc = Array.from(new Set(this.lstPerson.map((item: any) => item.StudentActiveDesc))).sort();
				this.lstParentActiveDesc = Array.from(new Set(this.lstPerson.map((item: any) => item.ParentActiveDesc))).sort();
				this.lstValidEntryDesc = Array.from(new Set(this.lstPerson.map((item: any) => item.ValidEntryDesc))).sort();
				this.lstProgressDesc = Array.from(new Set(this.lstPerson.map((item: any) => item.ProgressDesc))).sort();

				this.loading = false;

				// this.LoadNext(0);
				this.LoadAll();
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	// LoadNext(CurrentIndex){
	//   console.log("Load Next: " + (CurrentIndex + 1) + "/" + (this.lstPerson.length));

	//   this.AnyLoading = true;

	//   if(CurrentIndex >= this.lstPerson.length){
	//     console.log("Finish Load Next");

	//     this.AnyLoading = false;

	//     return;
	//   }
	//   else{
	//     var row = this.lstPerson[CurrentIndex];

	//     row.ProgressInt = 1;
	//     row.ProgressDesc = "Loading";

	//     var result = this.notifyService.LoadImportPreviewNextStudent(this.lstPerson[CurrentIndex].StudentID);
	//     result.subscribe(
	//       response => {

	//         var data: any = response;

	//         row.PersonID = data.PersonID;
	//         row.StudentName = data.StudentName;
	//         row.SchoolName = data.SchoolName;
	//         row.StudentActive = data.StudentActive;
	//         row.StudentActiveDesc = data.StudentActiveDesc;
	//         row.ProgressInt = data.ProgressInt;
	//         row.ProgressDesc = data.ProgressDesc;

	//         var Valid: any = false;

	//         Valid = data.ValidEntry == true; //&& row.ParentName != '' && row.ParentEmail != '';

	//         row.ValidEntry = Valid == true ? 1 : 0;
	//         row.ValidEntryDesc = Valid == true ? "Valid" : "Invalid";

	//         //Load Data Filter Lists
	//         this.lstSchoolName = Array.from(new Set(this.lstPerson.map((item: any) => item.SchoolName))).sort();
	//         this.lstStudentActiveDesc = Array.from(new Set(this.lstPerson.map((item: any) => item.StudentActiveDesc))).sort();
	//         this.lstParentActiveDesc = Array.from(new Set(this.lstPerson.map((item: any) => item.ParentActiveDesc))).sort();
	//         this.lstValidEntryDesc = Array.from(new Set(this.lstPerson.map((item: any) => item.ValidEntryDesc))).sort();
	//         this.lstProgressDesc = Array.from(new Set(this.lstPerson.map((item: any) => item.ProgressDesc))).sort();

	//         this.LoadNext(CurrentIndex + 1);
	//       },
	//       error => {
	//       }
	//     );

	//   }
	// }

	LoadAll() {
		//
		// Create Request
		//
		let lstStudentIDs: string[] = Array.from(new Set(this.lstPerson.map((item: any) => String(item.StudentID))));
		lstStudentIDs = lstStudentIDs.sort();

		let parms: GuardianImportPreviewRequest = {
			lstStudentIDs: lstStudentIDs,
		};

		var result = this.notifyService.LoadImportPreviewAll(parms);
		result.subscribe(
			(response) => {
				var data: any = response;

				//
				// Create dictionary (js Map) of student data so the data can be looked up later
				// (There might be repeated Student IDs)
				//
				let StudentData: Map<string, any> = new Map();

				for (var z = 0; z < data.length; z++) {
					var next = data[z];

					StudentData.set(next.StudentID, next);
				}

				//
				// Go through person list
				// Update with data from dictionary
				//

				for (var z = 0; z < this.lstPerson.length; z++) {
					var nextPerson = this.lstPerson[z];
					var nextData = StudentData.get(nextPerson.StudentID); //Search for data in dictionary

					nextPerson.PersonID = nextData.PersonID;
					nextPerson.StudentName = nextData.StudentName;
					nextPerson.SchoolName = nextData.SchoolName;
					nextPerson.StudentActive = nextData.StudentActive;
					nextPerson.StudentActiveDesc = nextData.StudentActiveDesc;
					nextPerson.ProgressInt = nextData.ProgressInt;
					nextPerson.ProgressDesc = nextData.ProgressDesc;
					nextPerson.ValidEntry = nextData.ValidEntry == true ? 1 : 0;
					nextPerson.ValidEntryDesc = nextData.ValidEntryDesc;
					nextPerson.ProgressInt = nextData.ProgressInt;
					nextPerson.ProgressDesc = nextData.ProgressDesc;
				}

				//Load Data Filter Lists
				this.lstSchoolName = Array.from(new Set(this.lstPerson.map((item: any) => item.SchoolName))).sort();
				this.lstStudentActiveDesc = Array.from(new Set(this.lstPerson.map((item: any) => item.StudentActiveDesc))).sort();
				this.lstParentActiveDesc = Array.from(new Set(this.lstPerson.map((item: any) => item.ParentActiveDesc))).sort();
				this.lstValidEntryDesc = Array.from(new Set(this.lstPerson.map((item: any) => item.ValidEntryDesc))).sort();
				this.lstProgressDesc = Array.from(new Set(this.lstPerson.map((item: any) => item.ProgressDesc))).sort();
			},
			(error) => {}
		);
	}

	loadNotifyLanguages() {
		var result = this.notifyService.NotifyLanguageSelectList();
		result.subscribe(
			(response) => {
				this.lstNotifyLanguages = response;
			},
			(error) => {}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.loadPerson();
	}

	//Custom Button Methods

	onRemove(Person) {
		this.lstPerson = this.lstPerson.filter((p) => p.UID != Person.UID); //UID added to each row so you don't delete multiple
		this.onRowUnselect(null);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectedPerson = val.data;
	}
	onRowUnselect(val) {
		this.SelectedPerson = null;
	}
	onRowDblClick(Person) {
		this.SelectedPerson = Person;
		// this.onEditPerson();
	}
	////////////////////////////////////////////

	GetColorDesc(ProgressInt) {
		if (ProgressInt == 0) {
			return "orangered";
		} else if (ProgressInt == 1) {
			return "orange";
		} else if (ProgressInt == 2) {
			return "green";
		}
	}
}
